import { NavLink } from 'react-router';
import { useLocation } from 'react-router';
import { cn } from '../ui/utils';
import { useEnterpriseOrg } from '../../context/EnterpriseOrgContext';
import { workspacePath } from '../../lib/enterprise-work-routes';

const LINKS = [
  { leaf: 'home', label: 'Home' },
  { leaf: 'timeline', label: 'Timeline' },
  { leaf: 'insights', label: 'Insights' },
  { leaf: 'interventions', label: 'Interventions' },
  { leaf: 'observability', label: 'Observability' },
  { leaf: 'check-in', label: 'Check-in' },
  { leaf: 'settings', label: 'Settings' },
  { to: '/enterprise/admin', label: 'Admin' },
] as const;

export function EnterpriseWorkspaceNav() {
  const { activeOrgId } = useEnterpriseOrg();
  const location = useLocation();
  const navLabel = location.pathname.startsWith('/work') ? 'Employee workspace' : 'Enterprise workspace';

  return (
    <nav className="sticky top-0 z-40 border-b border-slate-200 bg-white/98 shadow-[0_10px_24px_rgba(15,23,42,0.08)] backdrop-blur-[6px]">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-2 px-4 py-3">
        <p className="mr-2 text-xs font-semibold uppercase tracking-wide text-slate-500">{navLabel}</p>
        {LINKS.map((item) => {
          const to = 'leaf' in item
            ? workspacePath(location.pathname, item.leaf)
            : activeOrgId
              ? `${item.to}?org=${encodeURIComponent(activeOrgId)}`
              : item.to;
          return (
            <NavLink
              key={'leaf' in item ? item.leaf : item.to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-2.5 py-1.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100 hover:text-slate-900',
                  isActive && 'bg-slate-900 text-white',
                )
              }
            >
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}

